// Number formatting of Analytics (es). A null rate is "N/D" (no denominator), never 0 %.
const integer = new Intl.NumberFormat("es");
const compact = new Intl.NumberFormat("es", { notation: "compact", maximumFractionDigits: 1 });
const percent = new Intl.NumberFormat("es", { style: "percent", maximumFractionDigits: 1 });
const decimal = new Intl.NumberFormat("es", { maximumFractionDigits: 1 });

export const formatNumber = (n: number, short = false) =>
  (short && Math.abs(n) >= 10_000 ? compact : integer).format(n);
export const formatRate = (r: number | null | undefined) => (r === null || r === undefined ? "N/D" : percent.format(r));
export const formatDecimal = (n: number | null | undefined) =>
  n === null || n === undefined ? "—" : decimal.format(n);
export const formatSeconds = (s: number | null | undefined) =>
  s === null || s === undefined ? "—" : s < 60 ? `${decimal.format(s)} s` : `${decimal.format(s / 60)} min`;

/** Local day (YYYY-MM-DD) `daysAgo` days before today in the browser's time zone. */
export function localDay(daysAgo = 0, now = new Date()): string {
  const d = new Date(now.getTime() - daysAgo * 86_400_000);
  return `${String(d.getFullYear())}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** Browser offset in minutes east of UTC (the API's `tz`). */
export const browserOffsetMinutes = (now = new Date()) => -now.getTimezoneOffset();

/** Names of the gesture events (GESTURE_EVENT_TYPES) for the person reading the dashboard. */
const INTERACTION_TYPE_LABELS: Readonly<Record<string, string>> = {
  cta_click: "Clics de salida",
  game_interaction: "Interacciones de juego y anuncios HTML5",
  element_interaction: "Toques en elementos",
  carousel_navigate: "Navegación de carrusel",
  answer: "Respuestas de encuesta",
  form_interaction: "Campos de formulario",
  form_submit: "Envíos de formulario",
  media_control: "Controles de video o audio",
  restart: "Reinicios",
};
export const interactionTypeLabel = (type: string) => INTERACTION_TYPE_LABELS[type] ?? "Otras interacciones";
